import React, { useRef } from 'react'
import Editor from '@toast-ui/react-image-editor'
import './ImageEditor.sass'
import 'tui-image-editor/dist/tui-image-editor.min.css'
import Backdrop from '../../../ui/Backdrop/Backdrop'
import Icon from '../../../ui/Icon/Icon'
import Button from '../../../ui/Button/Button'

const ImageEditor = React.forwardRef(({ image, close, onEdit }, ref) => {
  const editorConfig = {
    loadImage: {
      path: image,
      name: 'SampleImage',
    },
    menu: ['rotate', 'flip', 'crop'],
    uiSize: {
      width: '1200px',
      height: '800px',
    },
    menuBarPosition: 'bottom',
    // locale: editorLocale,
  }

  const editorRef = useRef()

  const onImageEdit = () => {
    const instance = editorRef.current.getInstance()
    const imageDataURL = instance.toDataURL()
    onEdit(imageDataURL)
    close()
  }

  return (
    <Backdrop show close={close}>
      <div className="ImageEditor">
        <div className="ImageEditor-CloseButton" onClick={close}>
          <Icon name="times" />
        </div>
        <Editor
          ref={editorRef}
          includeUI={editorConfig}
          cssMaxHeight={500}
          cssMaxWidth={700}
          selectionStyle={{
            cornerSize: 20,
            rotatingPointOffset: 70,
          }}
          usageStatistics={false}
        />
        <Button title="Зберегти" theme="solid" fill="accent" className="ImageEditor-SaveButton" onClick={onImageEdit} />
      </div>
    </Backdrop>
  )
})

export default ImageEditor
